import { useHasPermission } from '../../hooks/useHasPermission';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/contracts/contractsPageHeader.css';

const ContractPageHeader = ({ setOpenAddContract }) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const hasContractCreatePermission = useHasPermission('contract_create');

    const handleAddContract = useCallback(() => {
        setOpenAddContract(true);
    }, [setOpenAddContract]);

    return (
        <Box className='contract_headre_main_container'>
            <Box className='contract_headre_title_box'>
                <Typography className='contract_headre_page_title'>Contrats</Typography>
            </Box>
            {(isDesktop && hasContractCreatePermission) &&
                <Box className='contract_headre_action_box' onClick={handleAddContract}>
                    <Iconify className='contract_headre_add_icon' icon="ic:baseline-plus" />
                    <Typography className='contract_headre_action_title'>{t("addContractDialogeTitle")}</Typography>
                </Box>
            }
            {(!isDesktop && hasContractCreatePermission) &&
                <Box className='contract_headre_action_box'>
                    <Iconify className='contract_headre_add_icon' icon="ic:baseline-plus" onClick={handleAddContract} />
                </Box>
            }
        </Box>

    );
};

export default React.memo(ContractPageHeader);